// Source authorship belongs to the original capture, never its reviewer.
export const getCareSourceAttribution = (source = {}) => ({
  authorId:
    source.authorId ||
    source.loggedBy?.id ||
    source.createdBy ||
    source.capturedBy?.id ||
    "",
  authorName:
    source.authorName || source.loggedBy?.name || source.capturedBy?.name || "",
  capturedAt: source.capturedAt || source.createdAt || null,
});
